import { twc } from "../utils";

/** Rounded muted container for grouped trace entries. */
export const TraceGroup = twc.div`flex flex-col gap-0.5 rounded-lg bg-secondary/20 px-2 py-1`;
